import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

/** Single source of truth for financial-UI visibility.
 *  Reads settings.use_prices (workshop toggle) + user.role to decide.
 *  Returns { enabled, defaultVat, vatOptions } — `enabled` is false either
 *  because the workshop disabled pricing OR because the user is a mechanic.
 */
export function usePricing() {
  const { user } = useAuth();
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get("/settings").then((r) => { if (alive) setSettings(r.data); }).catch(() => {});
    return () => { alive = false; };
  }, []);
  const canRoleSee = user?.role === "owner" || user?.role === "admin";
  const workshopEnabled = settings?.use_prices !== false; // undefined → true (default on)
  const enabled = !!(canRoleSee && workshopEnabled);
  const defaultVat = Number(settings?.default_vat_rate ?? 19);
  // Two quick presets + the workshop default; deduplicated.
  const vatOptions = Array.from(new Set([0, 19, defaultVat].map((v) => Number(v))))
    .filter((n) => !Number.isNaN(n));
  return { enabled, defaultVat, vatOptions, workshopEnabled, canRoleSee };
}
